// extracted by mini-css-extract-plugin
export default {"modal":"DocumentChooseAnotherModal_modal__aG0+P","body":"DocumentChooseAnotherModal_body__4eVko","option":"DocumentChooseAnotherModal_option__XGcSM"};